import { AxiosPromise }     from "axios";
import { Dispatch }         from "redux";
import NoticeRepository     from "../../../domain/notice/NoticeRepository";
import Notices              from "../../../domain/notice/Notices";
import { ApiClient }        from "../../configure/ApiClientConfig";
import { getNoticesAction } from "../../redux/notice/NoticeAction";

class NoticeDataSource implements NoticeRepository {
  readonly dispatch: Dispatch;

  constructor(dispatch: Dispatch) {
    this.dispatch = dispatch;
  }

  public findByPublish(): AxiosPromise<any> {
    return ApiClient.get("/notice/publish");
  }

  store(notices: Notices): void {
    this.dispatch(getNoticesAction(notices));
  }

}

export default NoticeDataSource;
